export default __webpack_public_path__ + "static/media/pants-normal-4.20c6a1ff.png";